import React, { useEffect, useState } from 'react'
import PalexLogoLight from '../../assests/img/logo blanco.png'
import '../../assests/styles/onboarding/landing.scss'
import { lgpdPolicyActions } from '../../actions/lgpdPolicy'
import { useDispatch } from 'react-redux'
import './lgpd.scss'

const LgpdPolicy = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const refLgpd = urlParams.get('referencia')
  const [actionCompleted, setActionCompleted] = useState(false)
  const [actionType, setActionType] = useState('')

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(lgpdPolicyActions.MarkAsReadLgpdPolicy(refLgpd))
  }, [])

  const handleAccept = () => {
    dispatch(lgpdPolicyActions.AcceptLgpdPolicy(refLgpd))

    // // Intentar cerrar la ventana
    // const closeAttempt = window.close()

    // Si sigue abierta, mostrar mensaje de confirmación
    setActionCompleted(true)
    setActionType('accepted')
  }

  const handleReject = () => {
    dispatch(lgpdPolicyActions.RejectLgpdPolicy(refLgpd))

    // // Intentar cerrar la ventana
    // window.close()

    // Si sigue abierta, mostrar mensaje de confirmación
    setActionCompleted(true)
    setActionType('rejected')
  }

  if (actionCompleted) {
    return (
      <div className='landing'>
        <img className='logo mb-80' src={PalexLogoLight} alt='Palex Logo'></img>
        <div className='lgpd-container'>
          <h2>Gracias por su respuesta</h2>
          <p>
            {actionType === 'accepted'
              ? 'Ha aceptado correctamente la política de privacidad.'
              : 'Ha rechazado la política de privacidad.'}
          </p>
          <p>Puede cerrar esta ventana de forma segura.</p>
        </div>
      </div>
    )
  }

  return (
    <div className='landing'>
      <img className='logo mb-80' src={PalexLogoLight} alt='Palex Logo'></img>
      <div className='lgpd-container'>
        <div className='btn-container'>
          <button className='btn' onClick={handleAccept}>
            Aceptar
          </button>
          <button className='btn' onClick={handleReject}>
            Cancelar
          </button>
        </div>
        He leído y acepto las condiciones contenidas en la política de
        privacidad sobre el tratamiento de mis datos para gestionar la
        inscripción en el registro web PALEX MEDICAL, S.A.U.
      </div>
    </div>
  )
}

export default LgpdPolicy
